
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indextREn9VZ7JUZ_45pcZKQWYZ_0LeMR1uS_454DSq9Qt7NlrjAMeta } from "/opt/build/repo/website/press-and-media/pages/press-and-media/index.vue?macro=true";
import { default as _91slug_93im_Zzk0Yp0WoPQSM3CkRYGh6rQVsqsh5PCplr_450eE3IMeta } from "/opt/build/repo/website/press-and-media/pages/press-and-media/[slug].vue?macro=true";
import { default as indexvdh078Tl0hb9ov42JtSrqjT4Ju_45FpX4qoFs4_0uvdfMMeta } from "/opt/build/repo/website/press-and-media/pages/press-and-media/newsroom/index.vue?macro=true";
import { default as indexDp2KDXLLBzAdXKNLt0RkNAplUWAxpjPbWn_IgnUuUKIMeta } from "/opt/build/repo/website/press-and-media/pages/press-and-media/presskit/index.vue?macro=true";
export default [
  {
    name: "press-and-media___en",
    path: "/press-and-media",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/index.vue")
  },
  {
    name: "press-and-media___en_AU",
    path: "/en_AU/press-and-media",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/index.vue")
  },
  {
    name: "press-and-media___pt_BR",
    path: "/pt_BR/imprensa-e-midia",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/index.vue")
  },
  {
    name: "press-and-media___zh_CN",
    path: "/zh_CN/press-and-media",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/index.vue")
  },
  {
    name: "press-and-media___da_DK",
    path: "/da_DK/presse-og-medier",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/index.vue")
  },
  {
    name: "press-and-media___de_DE",
    path: "/de_DE/presse-und-medien",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/index.vue")
  },
  {
    name: "press-and-media___es_ES",
    path: "/es_ES/notas-prensa",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/index.vue")
  },
  {
    name: "press-and-media___fr_FR",
    path: "/fr_FR/presse-et-medias",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/index.vue")
  },
  {
    name: "press-and-media___it_IT",
    path: "/it_IT/press-and-media",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/index.vue")
  },
  {
    name: "press-and-media___ja_JP",
    path: "/ja_JP/press-and-media",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/index.vue")
  },
  {
    name: "press-and-media___es_MX",
    path: "/es_MX/press-and-media",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/index.vue")
  },
  {
    name: "press-and-media___nl_NL",
    path: "/nl_NL/press-and-media",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/index.vue")
  },
  {
    name: "press-and-media___no_NO",
    path: "/no_NO/presse-og-media",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/index.vue")
  },
  {
    name: "press-and-media___pl_PL",
    path: "/pl_PL/prasa-i-media",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/index.vue")
  },
  {
    name: "press-and-media___pt_PT",
    path: "/pt_PT/press-and-media",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/index.vue")
  },
  {
    name: "press-and-media___sv_SE",
    path: "/sv_SE/press-och-media",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/index.vue")
  },
  {
    name: "press-and-media___en_AE",
    path: "/en_AE/press-and-media",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/index.vue")
  },
  {
    name: "press-and-media___en_SG",
    path: "/en_SG/press-and-media",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/index.vue")
  },
  {
    name: "press-and-media___en_GB",
    path: "/en_GB/press-and-media",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/index.vue")
  },
  {
    name: "press-and-media-slug___en",
    path: "/press-and-media/:slug()",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/[slug].vue")
  },
  {
    name: "press-and-media-slug___en_AU",
    path: "/en_AU/press-and-media/:slug()",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/[slug].vue")
  },
  {
    name: "press-and-media-slug___pt_BR",
    path: "/pt_BR/imprensa-e-midia/:slug()",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/[slug].vue")
  },
  {
    name: "press-and-media-slug___zh_CN",
    path: "/zh_CN/press-and-media/:slug()",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/[slug].vue")
  },
  {
    name: "press-and-media-slug___da_DK",
    path: "/da_DK/presse-og-medier/:slug()",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/[slug].vue")
  },
  {
    name: "press-and-media-slug___de_DE",
    path: "/de_DE/presse-und-medien/:slug()",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/[slug].vue")
  },
  {
    name: "press-and-media-slug___es_ES",
    path: "/es_ES/notas-prensa/:slug()",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/[slug].vue")
  },
  {
    name: "press-and-media-slug___fr_FR",
    path: "/fr_FR/presse-et-medias/:slug()",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/[slug].vue")
  },
  {
    name: "press-and-media-slug___it_IT",
    path: "/it_IT/press-and-media/:slug()",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/[slug].vue")
  },
  {
    name: "press-and-media-slug___ja_JP",
    path: "/ja_JP/press-and-media/:slug()",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/[slug].vue")
  },
  {
    name: "press-and-media-slug___es_MX",
    path: "/es_MX/press-and-media/:slug()",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/[slug].vue")
  },
  {
    name: "press-and-media-slug___nl_NL",
    path: "/nl_NL/press-and-media/:slug()",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/[slug].vue")
  },
  {
    name: "press-and-media-slug___no_NO",
    path: "/no_NO/presse-og-media/:slug()",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/[slug].vue")
  },
  {
    name: "press-and-media-slug___pl_PL",
    path: "/pl_PL/prasa-i-media/:slug()",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/[slug].vue")
  },
  {
    name: "press-and-media-slug___pt_PT",
    path: "/pt_PT/press-and-media/:slug()",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/[slug].vue")
  },
  {
    name: "press-and-media-slug___sv_SE",
    path: "/sv_SE/press-och-media/:slug()",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/[slug].vue")
  },
  {
    name: "press-and-media-slug___en_AE",
    path: "/en_AE/press-and-media/:slug()",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/[slug].vue")
  },
  {
    name: "press-and-media-slug___en_SG",
    path: "/en_SG/press-and-media/:slug()",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/[slug].vue")
  },
  {
    name: "press-and-media-slug___en_GB",
    path: "/en_GB/press-and-media/:slug()",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/[slug].vue")
  },
  {
    name: "press-and-media-newsroom___en",
    path: "/press-and-media/newsroom",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/newsroom/index.vue")
  },
  {
    name: "press-and-media-newsroom___en_AU",
    path: "/en_AU/press-and-media/newsroom",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/newsroom/index.vue")
  },
  {
    name: "press-and-media-newsroom___pt_BR",
    path: "/pt_BR/imprensa-e-midia/press-releases",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/newsroom/index.vue")
  },
  {
    name: "press-and-media-newsroom___zh_CN",
    path: "/zh_CN/press-and-media/press-releases",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/newsroom/index.vue")
  },
  {
    name: "press-and-media-newsroom___da_DK",
    path: "/da_DK/presse-og-medier/pressemeddelelser",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/newsroom/index.vue")
  },
  {
    name: "press-and-media-newsroom___de_DE",
    path: "/de_DE/presse-und-medien/press-releases",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/newsroom/index.vue")
  },
  {
    name: "press-and-media-newsroom___es_ES",
    path: "/es_ES/notas-prensa/press-releases",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/newsroom/index.vue")
  },
  {
    name: "press-and-media-newsroom___fr_FR",
    path: "/fr_FR/presse-et-medias/press-releases",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/newsroom/index.vue")
  },
  {
    name: "press-and-media-newsroom___it_IT",
    path: "/it_IT/press-and-media/press-releases",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/newsroom/index.vue")
  },
  {
    name: "press-and-media-newsroom___ja_JP",
    path: "/ja_JP/press-and-media/press-releases",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/newsroom/index.vue")
  },
  {
    name: "press-and-media-newsroom___es_MX",
    path: "/es_MX/press-and-media/press-releases",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/newsroom/index.vue")
  },
  {
    name: "press-and-media-newsroom___nl_NL",
    path: "/nl_NL/press-and-media/press-releases",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/newsroom/index.vue")
  },
  {
    name: "press-and-media-newsroom___no_NO",
    path: "/no_NO/presse-og-media/pressemeldinger",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/newsroom/index.vue")
  },
  {
    name: "press-and-media-newsroom___pt_PT",
    path: "/pt_PT/press-and-media/newsroom",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/newsroom/index.vue")
  },
  {
    name: "press-and-media-newsroom___sv_SE",
    path: "/sv_SE/press-och-media/pressmeddelanden",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/newsroom/index.vue")
  },
  {
    name: "press-and-media-newsroom___en_AE",
    path: "/en_AE/press-and-media/newsroom",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/newsroom/index.vue")
  },
  {
    name: "press-and-media-newsroom___en_SG",
    path: "/en_SG/press-and-media/newsroom",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/newsroom/index.vue")
  },
  {
    name: "press-and-media-newsroom___en_GB",
    path: "/en_GB/press-and-media/press-releases",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/newsroom/index.vue")
  },
  {
    name: "press-and-media-presskit___en",
    path: "/press-and-media/presskit",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/presskit/index.vue")
  },
  {
    name: "press-and-media-presskit___en_AU",
    path: "/en_AU/press-and-media/presskit",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/presskit/index.vue")
  },
  {
    name: "press-and-media-presskit___en_SG",
    path: "/en_SG/press-and-media/presskit",
    component: () => import("/opt/build/repo/website/press-and-media/pages/press-and-media/presskit/index.vue")
  }
]